import type { AfterViewInit, OnDestroy } from '@angular/core';
import { Directive } from '@angular/core';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { FileNotificationService } from '../file-notification.service';
import { FileHandlerDirective, FileReadStatus } from './file-handler.directive';

@Directive({
  selector: '[rtFileHandler][rtFileHandlerDefaultValidator]',
  standalone: true,
})
export class FileHandlerDefaultValidatorDirective implements AfterViewInit, OnDestroy {
  private ngOnDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private notify: FileNotificationService,
    private fileHandler: FileHandlerDirective,
  ) {}

  public ngAfterViewInit(): void {
    if (!this.fileHandler.shouldValidate) {
      return;
    }

    this.fileHandler.rtFileHandlerNextFile
      .pipe(
        filter(next => next.status !== FileReadStatus.OK),
        takeUntil(this.ngOnDestroy$),
      )
      .subscribe(next => {
        switch (next.status) {
          case FileReadStatus.FILE_SIZE_EXCEEDED:
            this.notify.notifySizeExceeded(<File>next.files, this.fileHandler.maxSize());
            break;
          case FileReadStatus.FILE_EXTENSION_NOT_SUPPORTED:
            this.notify.notifyInvalidExtension();
            break;
          default:
        }
      });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
